export default "__VITE_ASSET__Ccrsh6Vo__"